import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLeadAttribution } from "./utils/leadAttribution";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import CivilEngineering from "./pages/CivilEngineering";
import WaterWastewater from "./pages/WaterWastewater";
import Permitting from "./pages/Permitting";
import ProjectManagement from "./pages/ProjectManagement";
import { ContactPage } from "./pages/ContactPage";

function CaptureLeadAttribution() {
	const location = useLocation();
	useEffect(() => { getLeadAttribution(); }, [location.pathname, location.search]);
	return null;
}

export default function App() {
	return (
		<Router>
			<CaptureLeadAttribution />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/civil-engineering" element={<CivilEngineering />} />
				<Route path="/water-wastewater" element={<WaterWastewater />} />
				<Route path="/permitting" element={<Permitting />} />
				<Route path="/project-management" element={<ProjectManagement />} />
				<Route path="/contact" element={<ContactPage />} />
			</Routes>
			<Analytics />
			<Toaster position="top-right" richColors closeButton duration={5000} />
		</Router>
	);
}
